export const send = () => (
  <path
    d="M22 2L11 13M22 2l-7 20-4-9M22 2L2 9l9 4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
